/*
 * Created Date: Thursday May 5th 2022
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */

import { FC, useEffect, useMemo, useState } from "react";
import InputNumber from "rc-input-number";
import Stack from "@mui/material/Stack";
import ThemeManager from "../../../../web/app/src/components/ThemeManager";

interface NumberInputProps {
  value?: number;
  disabled?: boolean;
  onChange?: (value: number | null) => void;
  unit?: string;
}

const NumberInputCustom: FC<NumberInputProps> = (props) => {
  const { value = 0, disabled = false, onChange, unit = "m" } = props;

  const [tempValue, setTempValue] = useState<number | null>(null);

  const adaptiveSize = useMemo(() => {
    if (tempValue === null || !tempValue) {
      return 1;
    } else {
      return tempValue.toString().replace(".", "").length;
    }
  }, [tempValue]);

  useEffect(() => {
    if (value) setTempValue(value);
  }, [value]);

  return (
    <ThemeManager>
      <Stack
        flexDirection="row"
        alignItems="baseline"
        borderRadius="24px"
        bgcolor="primary.main"
        color="text.primary"
        padding="2px 10px"
        sx={{
          "& .rc-input-number .rc-input-number-input": {
            backgroundColor: "transparent",
            border: "none",
            color: "text.primary",
            fontSize: "14px",
            width: `${adaptiveSize * 12}px`,
          },
          "& .rc-input-number-input:focus": {
            outline: "none",
          },
        }}
      >
        <InputNumber
          disabled={disabled}
          value={value}
          onChange={(val) => {
            setTempValue(val);
          }}
          onBlur={() => {
            onChange?.(tempValue);
          }}
          onPressEnter={() => {
            onChange?.(tempValue);
          }}
          decimalSeparator="."
          parser={(displayValue?: string) => {
            /** replace , with . */
            if (!displayValue) return 0;

            return parseFloat(displayValue.replace(",", "."));
          }}
          size={adaptiveSize}
        />
        <div
          style={{
            userSelect: "none",
            fontSize: "14px",
            color: "white",
          }}
        >
          {unit}
        </div>
      </Stack>
    </ThemeManager>
  );
};

export default NumberInputCustom;
